/**
 * Web Clipboard Implementation
 */

import type { Clipboard, ClipboardResult } from "./types";

/**
 * Copy text to clipboard
 */
const copy = async (text: string): Promise<ClipboardResult> => {
  try {
    if (!text) {
      return { success: false, error: new Error("No text provided") };
    }
    await navigator.clipboard.writeText(text);
    return { success: true };
  } catch (error) {
    return { success: false, error: error as Error };
  }
};

/**
 * Paste text from clipboard
 */
const paste = async (): Promise<string | null> => {
  try {
    return await navigator.clipboard.readText();
  } catch (error) {
    console.error("Error reading from clipboard:", error);
    return null;
  }
};

export const clipboard: Clipboard = {
  copy,
  paste,
};

export { copy as copyToClipboard };
